import { toast } from 'react-toastify';
import Icon from 'common/components/elements/icons';

const positionToasterContainer = async (top) => {
   await setTimeout(() => { }, 0)
   let header = null;
   let topOffset = 12;
   const elem = document.getElementsByClassName('page__header');
   if(elem) {
      header = elem[0]
   }
   if(top){
      const toasterContainer = document.getElementsByClassName('ams-toast-container')[0];
      if(toasterContainer) {
         toasterContainer.style.top = top;
      }
      return
   }
   if(header) {
      topOffset += header.clientHeight;
      const toasterContainer = document.getElementsByClassName('ams-toast-container')[0];
      if(toasterContainer) {
         toasterContainer.style.top = `${ topOffset }px`;
      }
   } else {
      topOffset += 44;
      const toasterContainer = document.getElementsByClassName('ams-toast-container')[0];
      if(toasterContainer) {
         toasterContainer.style.top = `${ topOffset }px`;
         toasterContainer.style.marginRight = `16px`;
         toasterContainer.style.marginLeft = `16px`;
      }
   }
}

export { positionToasterContainer }

const generateOptions = (options) => {
   const iconName = options.icon

   if(iconName){
      options = {
         ...options,
         icon: ({ theme, type }) => <Icon name={ iconName } color='major-dark' size='xl' />,
      }
   }

   if(options.undo){
      options = {
         ...options,
         className: 'ams-toast bg-gray-800 shadow-small',
      }
   }

   return options
}

const generateText = (text, options) => {

   if(!options.undo) return text

   return (
      <div className='flex items-center gap-2'>
         <p className='border-r border-gray-700 pr-2 text-gray-50 font-medium'>{text}</p>
         <button
            onClick={ options.undo }
            className='text-sm font-semibold cursor-pointer text-gray-50 '
         >
            Undo
         </button>
      </div>
   )

}

export default {
   remove(text, options = {}) {
      toast(generateText(text, options), {
         className: 'ams-toast bg-success dark:bg-success-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(options),
      });
   },
   success(text, options = {}) {
      toast(generateText(text, options), {
         className: 'ams-toast bg-success dark:bg-success-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(options),
      });
   },
   error(text, options = {}) {
      toast(generateText(text, options), {
         className: 'ams-toast bg-error dark:bg-error-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(options),
      });
   },
   info(text, options = {}) {
      toast(generateText(text, options), {
         className: 'ams-toast bg-success dark:bg-success-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(options),
      });
   },
   warning(text, options = {}) {
      const newOptions = {
         ...options,
         icon: 'warning',
      }
      toast(generateText(text, options), {
         className: 'ams-toast bg-orange dark:bg-orange-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(newOptions),
      });
   },
   notice(text, options = {}) {
      const newOptions = {
         ...options,
         icon: 'warning',
      }
      toast(generateText(text, options), {
         className: 'ams-toast bg-blue dark:bg-blue-dark',
         closeButton: false,
         draggable: false,
         onOpen: positionToasterContainer,
         ...generateOptions(newOptions),
      });
   },
};
